<template>
  <div class="van-dialog">
    <el-dialog :visible.sync="show"
               :show-close="showClose"
               :destroy-on-close="destroyOnClose"
               :modal="modal"
               width="960px" top="10vh"
               :showClose="!isDisableClose"
               :close-on-click-modal="closeOnClickModal"
               :close-on-press-escape="!isDisableClose"
               :modal-append-to-body="modalAppendToday"
               :append-to-body="appendToday"
    >
      <div class="dialog-title" slot="title">
        <slot name="title"></slot>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="dialog-footer"
           v-if="isShowFooter"
           slot="footer">
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
  components: {
    ElDialog: Dialog,
  },
  props: {
    showClose: {
      type: Boolean,
      default: true,
    },
    destroyOnClose: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: true,
    },
    skin: {
      type: String,
      default: '',
    },
    isDisableClose: {
      type: Boolean,
      default: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
    isShowFooter: {
      type: Boolean,
      default: false,
    },
    modalAppendToday: {
      type: Boolean,
      default: false,
    },
    appendToday: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';

  .van-dialog {
    .el-dialog {
      box-sizing: border-box;
      max-height: 100vh;
      border-radius: 24px;
      overflow: hidden;
      .dialog-title {
        padding-left: 20px;
        height: 50px;
        color: #fff;
        font-size: 3vh;
        line-height: 50px;
        font-weight: 700;
        background: $primary;
        overflow: hidden;
      }
      .el-dialog__header {
        font-size: 18px;
        padding: 0;
        .title {
          height: 50px;
          line-height: 50px;
          padding: 0 12px;
          margin: 0;
          /*border-radius: 24px;*/
          overflow: hidden;
        }
        .el-dialog__headerbtn {
          top: 10px;
          width: 30px;
          height: 30px;
          background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/e4f688b8d4e34ef78964f2cef65f5138.png') no-repeat;
          background-size: 100% 100%;
          border-radius: 50%;
          .el-icon-close {
            color: transparent;
          }
        }
        .el-progress-bar {
          display: block;
        }
      }
      .el-dialog__footer {
        border-top: 1px solid $gray-bg-color;
        padding: 15px 20px;
      }
      .el-dialog__body {
        padding: 0;
        .content {
          position: relative;
          padding: 20px;
        }
      }
    }
  }
</style>
